import { Dialog } from "construct-ui";
import ViewBase from "../view-base.view";
import PurchaseOrderProposalModel from "../../models/purchase-order-proposal/purchase-order-proposal.model";
import moment from "moment";
import { formats } from "../../config/constants";
import FileUploadInputComponent from "../../components/file/file-upload-input.component";

/**
 * Purchase Order Proposal - Excel Upload Dialog
 * 
 * The upload dialog used to download and upload according to the filters provided
 * 
 * @author Darrus Goh
 */
export default function PurchaseOrderProposalExcelUploadDialog() {
    ViewBase.call(this);

    const ACCEPTED_FILE_FORMAT = '.xlsx';
    const FORM_ID = 'purchaseOrderExcelUploadForm';

    let uploadFile = null;

    const downloadPurchaseOrdersExcelFormat = (filters) => {
        this.showLoading();
        let params = {
            week: moment(filters.week, formats.WEEK_FORMAT).format('yyyyww'),
            channelCodes: !_.isEmpty(filters.sites) ? filters.sites.map((e) => e.code) : null,
            modelCodes: filters.models?.length > 0 ? filters.models : null
        };

        PurchaseOrderProposalModel.downloadPurchaseOrdersExcelFormat(params)
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    };

    const upload = (e) => {
        if (!this.validateForm(e)) {
            return false;
        }

        this.showLoading();
        PurchaseOrderProposalModel.uploadExcel(uploadFile)
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading();
            });
    }

    return {
        view: ({ attrs: { filters, isOpen, onClose } }) => {
            return m(Dialog,
                {
                    isOpen,
                    onClose,
                    class: 'cui-dialog-l',
                    title: this.getText('LT00000761', 'Batch Upload approval'),
                    content: m('container',
                        m('ol',
                            m('li.fw-bold.mb-4',
                                m('.mb-2', this.getText('LT00000018', 'Excel Download')),
                                m('button.btn.btn-primary', { onclick: () => { downloadPurchaseOrdersExcelFormat(filters); } }, m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText('LT00000744', 'Download Pending Records')),
                            ),
                            m('hr'),
                            m('li.fw-bold.mb-4',
                                m('.mb-2', m('label.mandatory', this.getText('LT00000197', 'Excel Upload'))),
                                m('form.position-relative.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                                    m('.row',
                                        m('.col-lg-9',
                                            m(FileUploadInputComponent, {
                                                accept: ACCEPTED_FILE_FORMAT,
                                                required: true,
                                                onInput: (file) => {
                                                    uploadFile = file;
                                                }
                                            }),
                                            m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                                        )
                                    )
                                )
                            )
                        ),
                        this.getBaseViews()
                    ),
                    footer: m('.d-flex.gap-2.justify-content-end',
                        m('button.btn.btn-primary', { type: 'submit', form: FORM_ID }, this.getText("LT00000290", "Upload")),
                        m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
                    )
                }
            );
        }
    }
}
